import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import { Brandmark } from '@/components/auth/auth-icons';
import { Spinner } from '@/components/ui/spinner';
import { useSignOut } from '@/hooks/use-sign-out';

export function LogoutPage() {
    const { isLoading } = useAuth0();
    const signOut = useSignOut();

    useEffect(() => {
        if (!isLoading) {
            signOut();
        }
    }, [signOut, isLoading]);

    return (
        <div className="relative z-10 flex w-full max-w-[420px] flex-col items-center gap-5 rounded-2xl border border-border bg-card px-9 py-10 shadow-[0_30px_60px_-24px_rgba(15,23,35,0.18),0_2px_6px_rgba(15,23,35,0.04)] dark:shadow-[0_30px_60px_-24px_rgba(0,0,0,0.6)]">
            <Brandmark className="h-7 w-7 text-[color:var(--auth-accent)]" />
            <div className="text-center">
                <h2 className="text-[20px] font-medium tracking-[-0.015em] text-foreground">Signing out…</h2>
                <p className="mt-1 text-sm text-muted-foreground">Please wait while we log you out.</p>
            </div>
            <Spinner className="h-7 w-7 text-primary" />
        </div>
    );
}
